<template>
	<div class="Aviso" v-if="!is_mobile">
		<div class="libe_home_nav" v-if="scroll >= 88">
			<headNav :activeNav="'Aviso'"></headNav>
		</div>
		<div class="eshoy_content_wrap">
			<div class="libe_homenav" v-if="scroll < 88">
				<homeNav :activeNav="'Aviso'"></homeNav>
			</div>

			<div class="eshoy_about_wrap">
				<div class="plapla_abmessage_cont">
					<div class="eshoy_abmessage_title">Aviso de Privacidad</div>
					<div class="eshoy_abmessage_view">
						<div class="content">
							<p>Actualización: 2026-03-04</p>
							<p>
								En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante la "Ley"), su Reglamento y los Lineamientos del Aviso de Privacidad, estos últimos publicados en el Diario Oficial de la Federación de fecha 17 de enero de 2013, Madaeli, S.A. de C.V.y su aplicación Pla Pla pone a su disposición el presente Aviso de Privacidad y hace de su conocimiento los términos y condiciones siguientes:
							</p>
							<p style="font-weight: bold">Actividad en apps</p>
							<p>
								Necesitamos obtener la actividad en apps, incluido nombre del paquete, nombre de la aplicación, la hora de la primera instalación y la hora de actualización de la aplicación, para evaluar si el cliente es elegible para solicitar un préstamo. Cargaremos esta información a nuestro servidor https://api.plapla.com.mx encriptado, y se usa para identificar y analizar comportamiento y riesgo en múltiples préstamos para evaluar si un préstamo puede procesarse, lo que ayuda a prevenir el fraude.
							</p>
							<p style="font-weight: bold">I. Del Tratamiento de los Datos Personales.</p>
							<p>
								Madaeli, S.A. de C.V.(en lo sucesivo Madaeli) y su aplicación Pla Pla, con domicilio en RIO SAN JOAQUIN 463 Popo Miguel Hidalgo Ciudad de México 11480, es responsable de la obtención, uso, divulgación, o almacenamiento, acceso, manejo, aprovechamiento, transferencia o disposición de datos personales (Adelante "Tratamiento").
							</p>
							<p>
								Sus datos serán almacenados en los servidores seguros de Madaeli, S.A. de C.V. ubicados en: https://api.plapla.com.mx
							</p>
							<p>
								En ningún caso compartiremos ni venderemos sus datos a terceros. Si desea eliminar su información personal, puede enviar una solicitud al servicio de atención al cliente al correo: plapla.service.2@gmail.com y procederemos a la eliminación manual en un plazo de 3 a 5 días hábiles. Alternativamente, puede enviar la solicitud directamente en la aplicación, en Configuración > Eliminar cuenta, y eliminaremos sus datos personales en un máximo de 7 días hábiles.La eliminación estará sujeta a lo establecido en la Ley Fintech y demás normativas aplicables en materia de conservación de registros.
							</p>
							<p style="font-weight: bold">II. Datos Personales sujetos a Tratamiento.</p>
							<p>
								Madaeli recabará Datos Personales necesarios para cumplir con su objeto social, políticas en materia de prevención y detección de operaciones con recursos de procedencia ilícita y financiamiento al terrorismo y demás políticas corporativas, ya sea personal, directamente a través de sus ejecutivos, funcionarios, empleados, promotores, o indirectamente por medio de sus asesores o comisionistas, pudiendo utilizar mecanismos en medios remotos o locales de comunicación electrónica, óptica u otra tecnología, como puede ser a través de nuestro portal web, aplicación, correo electrónico o postal, servicios en línea, vía telefónica, que le permitan recabar datos personales de manera automática y simultánea, incluyendo las referencias personales y comerciales que llegue a proporcionar el titular de la información.
							</p>
							<p>
								Según la versión de su aplicación, PlaPla podría requerir acceso a los siguientes permisos del dispositivo. Mantenga la aplicación PlaPla actualizada para garantizar el uso de funciones seguras y con las últimas mejoras.
							</p>
							<ul>
								<li>
									Datos de Identificación: nombre completo, dirección, teléfonos de contacto, estado civil, género, país, lugar y fecha de nacimiento, edad, identificación oficial vigente, registro federal de contribuyentes (RFC), clave única de registro de población (CURP), correo electrónico y sobre características físicas como son fotografías del poseedor de los datos o su domicilio, datos biométricos, geolocalización, entre otros.
								</li>
								<li>
									Datos Personales: informaciones laboral, salarios mensuales, día de cobro, nivel educativo, informaciones bancarias, tipo de cuenta, número de tarjeta.
								</li>
								<li>
									Datos de Contactos: nombre completo, número de teléfonos,La relación del .
								</li>
								<li>
									Datos Bancarios o patrimoniales: tipo de cuenta, número de tarjeta, cuenta CLABE, nombre del banco. Se utiliza para recibir desembolsos y evaluar crédito, a fin de determinar si cumple con los requisitos para usar nuestros servicios y establecer su línea de crédito.
								</li>
								<li>
									Datos de Cónyuge o Concubina: nombre completo, dirección, ocupación, teléfonos de contacto, estado civil, género, país, lugar y fecha de nacimiento, edad.
								</li>
								<li>
									<span style="font-weight: bold;">Leer tus transacciones financieras a través de SMS</span><span style="font-weight: bold;"> -</span>
									PlaPla accede únicamente a los mensajes SMS de carácter financiero almacenados en su dispositivo (incluyendo marcas de tiempo, números telefónicos y contenido de los mensajes), sin recopilar ningún dato no financiero de sus SMS ni compartir su contenido. Estos datos se procesan mediante modelos automatizados para evaluar solicitudes de préstamo, utilizando esta información en nuestros modelos de control de riesgos para determinar su elegibilidad para los servicios financieros. Toda la información se almacena de forma segura en nuestros servidores protegidos: https://api.plapla.com.mx. Nunca compartiremos datos con terceros sin su permiso, y la recopilación de SMS se realizará siempre bajo consentimiento. Si desea eliminar sus datos privados, puede enviar una solicitud al servicio de atención al cliente a este correo electrónico:plapla.service.2@gmail.com y podemos eliminarlos manualmente dentro de 3-5 días hábiles).
								</li>
								<li>
									Recibir mensajes de texto: PlaPla enviará mensajes de texto a su número móvil registrado, los cuales pueden incluir fechas límite de pago, actualizaciones de servicio y contenido promocional relevante. Adicionalmente, la función de recibir SMS se utiliza exclusivamente para la verificación automática de códigos OTP enviados a su dispositivo.
								</li>
								<!--<li>
									La función de vinculación de cuenta Google obtiene su correo electrónico, nombre e información de perfil para facilitar el inicio de sesión rápido, verificar la elegibilidad para préstamos y prevenir fraudes. Mejora su crédito y agiliza el acceso.
								</li>-->
								<li>
									Datos de Modelo y Estado del Dispositivo: información específica sobre su dispositivo, incluido su modelo de hardware, modelo de compilación, RAM, almacenamiento, identificadores únicos de dispositivo como número de serie, AAID, información SIM.
								</li>
								<li>
									Cooperadores: el SDK que utilizamos para conectar con el servicio de proveedor de Deeplink se entrega a través de múltiples canales (por ejemplo, Google, Facebook) con el fin de distinguir la fuente de atribución del canal del usuario y transmitir la identidad de cada canal, pero nuestro socio Deeplink no accede ni utiliza ninguna información de la cuenta social del usuario, tampoco nuestra propia app accede ni utiliza ninguna información de la cuenta social del usuario.
								</li>
								<li>
									Ubicación aproximada: Esta información contribuye a que nuestros modelos de detección de fraude verifiquen su identidad. PlaPla utiliza estos datos en sus modelos de control de riesgos para determinar su elegibilidad para acceder a los servicios de la plataforma.
								</li>
								<li>
									Cámara / Información de la imagen: Necesitamos obtener el permiso de cámara para tomar foto de identificación y foto facial.
								</li>
							</ul>
							<p>
								Los documentos proporcionados se utilizan exclusivamente para verificar que su solicitud de préstamo fue iniciada por usted mismo. Estas fotos se almacenarán en la nube para verificar la autenticidad del documento, la coherencia del usuario actual y del documento, que está diseñado para proteger sus fondos y optimizar sistema antifraude garantizando calidad de servicio de préstamo. Los datos se conservarán durante un año a partir de la fecha de carga. Las imágenes proporcionadas se utilizan para optimizar nuestros sistemas de prevención de fraude, garantizar la seguridad de sus fondos, verificar la autenticidad de los documentos y comprobar la correspondencia entre el solicitante actual y la identidad registrada. PlaPla no recopila imágenes sin su autorización expresa. Para solicitar la eliminación de estos datos, puede contactar a nuestro servicio al cliente enviando un correo electrónico a plapla.service.2@gmail.com, procediendo a la eliminación manual de la información dentro de un plazo de 3 a 5 días hábiles.
							</p>
							<p>
								Madaeli no recabará Datos Sensibles, es decir, aquellos que puedan revelar aspectos como origen racial o étnico, estado de salud presente y futuro, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas y preferencia sexual.
							</p>
							<ul>
								<li>
									Datos de Contactos: Necesitamos que seleccione manualmente el contactos de emergencia desde su lista de contactos incluido nombre y número de teléfono, esta función sirve para cuando no podemos poner en contacto contigo. Solamente los contactos seleccionados manualmente por los usuarios se transmitirán a nuestra aplicación de manera encriptada, y se guardarán por 1 año a partir de la fecha de carga. Nunca recopilaremos su información sin consentimiento. Si desea eliminar sus datos privados, puede enviar un correo electrónico a plapla.service.2@gmail.com. Envíe una solicitud al servicio de atención al cliente y podemos eliminarla manualmente dentro de (3-5 días hábiles).
								</li>
								<li>
									Datos de Permisos dentro del Dispositivo: en especifico, las informaciones que emiten tras la activación de permiso de ubicacion, informacion del usuario, camara.
								</li>
								<li>
									Notificaciones: Permiten a la aplicación PlaPla enviar alertas a su dispositivo. Puede desactivarlas en la configuración del sistema.
								</li>
								<li>
									Conectividad de red: Se utiliza para detectar cambios en la conexión y verificar su acceso a internet.
								</li>
								<li>
									Conexiones Wi-Fi: PlaPla analiza la dirección IP y tipo de red para prevenir actividades fraudulentas.
								</li>
								<li>
									Recepcion de datos de internet: Permite a la aplicación realizar solicitudes y acceder a servicios en línea.
								</li>
								<li>
									Adjust SDK: Utilizamos el SDK de Adjust para analizar el comportamiento de los usuarios dentro de la aplicación y la atribución de datos publicitarios. Consulte nuestra política de privacidad en: https://www.adjust.com/terms/privacy-policy
								</li>
								<li>
									AppsFlyer SDK: Utilizamos el SDK de AppsFlyerpara analizar el comportamiento de los usuarios dentro de la aplicación y la atribución de datos publicitarios. Políticas disponibles en: https://www.appsflyer.com/legal/privacy-policy/
								</li>
							</ul>
							<p>
								Todos los Datos Personales recabados serán tratados bajo estrictas medidas de seguridad, siempre garantizando su confidencialidad.
							</p>
							<p>
								Madaeli no recabará Datos Sensibles, es decir, aquellos que puedan revelar aspectos como origen racial o étnico, estado de salud presente y futuro, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas y preferencia sexual.
							</p>
							<p style="font-weight: bold">III.Finalidades del Tratamiento.</p>
							<p>
								Los Datos Personales que Madaeli recabe serán utilizados para realizar la verificación y confirmación de su identidad, análisis de riesgos, y que pudieran dar origen a una relación comercial entre Madaeli y usted como titular de los Datos Personales, siendo las finalidades:
							</p>
							<ul>
								<li>Dar cumplimiento a obligaciones contraídas con el Titular;</li>
								<li>
									Dar cumplimiento a obligaciones regulatorias emitidas por parte de las autoridades competentes, así como atender sus requerimientos;
								</li>
								<li>
									Mantener su información actualizada.
								</li>
								<li>
									Identificar al Titular.
								</li>
								<li>
									Evaluar riesgos y, en su caso, formalizar el contrato que derive de la relación comercial que se establezca entre las partes.
								</li>
								<li>
									Realizar validaciones de identidad a través de medios biométricos y biográficos de sus clientes.
								</li>
							</ul>
							<p>
								Los datos personales serán obtenidos y actualizados mediante los siguientes canales:
							</p>
							<p>
								1. Cuando descargue la aplicación PlaPla y/o solicite un préstamo con nosotros;
							</p>
							<p>
								2. A través de otras interacciones con nuestra organización, incluyendo información que comparta voluntariamente con nuestro servicio al cliente, empleados o agentes;
							</p>
							<p>
								3. Mediante instituciones de transferencia monetaria, proveedores de pagos electrónicos, plataformas de crowdfunding, entidades crediticias y otras instituciones financieras o de comercio electrónico, previo su consentimiento cuando sea requerido;
							</p>
							<p>
								4. A través de terceros y proveedores de servicios externos, siempre con su autorización expresa.
							</p>
							<p style="font-weight: bold">
								IV.Mecanismos para manifestación de negativa para tratamiento de sus Datos Personales.
							</p>
							<p>
								En caso de que no se encuentre de conformidad con el presente Aviso de Privacidad y del tratamiento de sus Datos Personales, contará con un plazo de 5 (cinco) días hábiles contados a partir de la entrega del presente Aviso de Privacidad para que, de ser el caso, manifieste su negativa para el tratamiento de sus Datos Personales.
							</p>
							<p>
								Para llevar a cabo el ejercicio de sus derechos de conformidad con lo señalado en el párrafo anterior, se pone a su disposición el correo electrónico plapla.service.2@gmail.com en el cual, dentro del asunto deberá señalar "Negativa para el Tratamiento de Datos Personales" manifestando en el cuerpo del correo sus datos de identificación a efecto de realizar lo conducente.
							</p>
							<p>
								En caso de manifestar su negativa para el tratamiento de sus Datos Personales en términos del presente Aviso de Privacidad, no se podrá concretar la relación jurídica, en el entendido que dicha información, es requerida para la prestación del servicio.
							</p>
							<p style="font-weight: bold">V.Transferencia de Datos.</p>
							<p>
								Madaeli podrá transferir sus Datos Personales a terceros, comprometiéndose a informar a dichos terceros del contenido del presente Aviso de Privacidad a fin de que tomen las medidas necesarias para respetar en todo momento los compromisos aquí descritos y asumidos por nosotros, mismos que serán extensivos para dichos terceros.
							</p>
							<p>
								Madaeli se cerciorará de que los terceros hayan emitido igualmente su correspondiente Aviso de Privacidad, cumpliendo así con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
							</p>
							<p>Los Datos Personales podrán ser transferidos a:</p>
							<ul class="number_ul">
								<li>
									Sociedades prestadoras de servicios, tales como: Trans Unión de México, S.A. S.I.C. (Buro de crédito), Circulo de crédito S.A. de C.V. S.I.C., Servicios Quien es Quien, S.A. de C.V., y cualquier otra que sea necesaria para verificar la identidad y veracidad de los datos proporcionados, únicamente con el propósito de dar cumplimiento a nuestras obligaciones legales y normativas derivadas de lo previsto en las leyes mexicanas.
								</li>
								<li>
									Autoridades mexicanas, cuando éstas lo requieran, para validar la autenticidad de los documentos presentados como identificación oficial por la contraparte.
								</li>
								<li>
									Autoridades financieras mexicanas y extranjeras, cuando éstas lo requieran con la finalidad de dar cumplimiento a nuestras obligaciones derivadas de leyes o tratados internacionales como entidad financiera, obligaciones tributarias, así como para el cumplimiento de notificaciones o requerimientos oficiales.
								</li>
								<li>
									Autoridades judiciales mexicanas y extranjeras, con la finalidad de dar cumplimiento a notificaciones, requerimientos u oficios de carácter judicial.
								</li>
								<li>
									Adjust GmbH: la función de este SDK es recopilar información sobre el origen de los usuarios y las operaciones que realizan en la plataforma.
								</li>
							</ul>
							<p>
								Todos los terceros mencionados pueden participar dentro de los procesos y cadena de valor ofrecida por Madaeli. En caso de ser necesaria la transferencia adicional de información que requiera su consentimiento expreso, éste se recabará con anticipación.
							</p>
							<p>
								Madaeli, podrá proporcionar información recabada previa y durante la vigencia de la relación jurídica entre las partes y para el cumplimiento de las obligaciones derivadas de lo anterior, a las entidades financieras que sean empresas controladoras, subsidiarias o filiales de Madaeli, así como a las autoridades competentes en México conforme a la legislación aplicable así como para el cumplimiento de obligaciones legales ante autoridades administrativas y judiciales garantizando previamente que dicha transferencia otorgue la continuidad de la protección de la información y el cumplimiento a lo señalado en el presente Aviso de Privacidad..
							</p>
							<p>
								El titular expresamente acepta y conviene que Madaeli podrá grabar cualquier comunicación telefónica que se realice entre el titular y Madaeli.
							</p>
							<p style="font-weight: bold">
								VI. Limitaciones en el uso y divulgación de sus Datos Personales y ejercicio de los derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)
							</p>
							<p>
								Usted tiene el derecho de acceder a sus Datos Personales que poseemos y a los detalles del tratamiento de estos, así como a rectificarlos en caso de ser inexactos o bien cancelar su uso a través de una solicitud mediante la presentación de un escrito libre dentro de las instalaciones de Madaeli, ubicadas en RIO SAN JOAQUIN 463 Popo Miguel Hidalgo Ciudad de México 11480; en un horario de 9:00 a 15:00 hrs., Teléfono 5593314662. Dicho requerimiento será atendido por la UNE (Unidad Especializada de Atención a Usuarios) en un plazo máximo de 20 (veinte) días hábiles, informándole sobre la procedencia a través del correo electrónico o el número telefónico que haya indicado en su solicitud y haciéndose efectiva, 15 (quince) días hábiles después de que se hubiera comunicado su resolución. Los plazos antes referidos podrán ser ampliados una sola vez por un periodo igual, siempre y cuando así lo justifiquen las circunstancias del caso, razones que se manifestarán al Titular, por escrito.
							</p>
							<p>
								Para ejercer los Derechos ARCO, el Titular, deberá presentar ante Madaeli, una solicitud que deberá contener y acompañar, como mínimo, lo siguiente:
							</p>
							<ul>
								<li>
									1. El nombre completo del Titular, domicilio y cuenta de correo electrónico o cualquier medio para comunicarle la respuesta a la solicitud.
								</li>
								<li>
									2. Los documentos que acrediten la identidad o, en su caso, la representación legal del Titular.
								</li>
								<li>
									3. La descripción clara y precisa de los Datos Personales sobre los cuales se desea ejercer algún Derecho ARCO.
								</li>
								<li>
									4. Para el caso de solicitar una rectificación, se deberá acompañar la documentación que respalde la rectificación solicitada.
								</li>
							</ul>
							<p>
								Madaeli se reserva el derecho de solicitar información y/o documentación adicional a la mencionada para atender la solicitud.
							</p>
							<p>
								Madaeli no estará obligado a cancelar los datos personales cuando: (i) Se refiera a las partes de un contrato y sean necesarios para su desarrollo y cumplimiento; (ii) deban ser tratados por disposición legal; (iii) sean necesarios para cumplir con una obligación legalmente adquirida por el Titular.
							</p>
							<p>
								La obligación de acceso a la información se dará por cumplida por parte de Madaeli, cuando ésta ponga a disposición del Titular de los Datos Personales directamente en el domicilio señalado en este inciso o se envíe al correo electrónico señalado por el Titular y elimine de su base de datos, dichos datos.
							</p>
							<p>
								Usted manifiesta expresamente que es de su conocimiento que en cualquier momento podrá oponerse al tratamiento de los datos que no sean esenciales para la relación jurídica y/o comercial que entabla con Madaeli, lo cual podrá efectuar mediante el procedimiento aquí señalado.
							</p>
							<p>
								En el tratamiento de sus datos personales, se prevé primordialmente que su resguardo sea contra todo daño, pérdida, alteración, destrucción, y ante todo uso, acceso o tratamiento no autorizado.
							</p>
							<p style="font-weight: bold">VII.Modificaciones al Aviso de Privacidad.</p>
							<p>
								Madaeli se reserva el derecho de efectuar en cualquier momento cambios o modificaciones al presente Aviso de Privacidad, ante la necesidad de proporcionarle la protección continua y adecuada a sus datos personales, así como para la atención de novedades legislativas o jurisprudenciales, políticas internas, y prácticas del mercado. Los cambios y modificaciones estarán disponibles a través de los siguientes medios: anuncios en nuestras oficinas y en el portal web de Madaeli, a través de nuestro personal que recabe sus Datos Personales y a través del envió a su último correo electrónico proporcionado.
							</p>
							<p style="font-weight: bold">VIII.Revocación del consentimiento.</p>
							<p>
								Como Titular de los Datos Personales podrá revocar el consentimiento concedido a Madaeli a fin de que se deje de hacer uso de los mismos, para lo cual se deberá seguir el procedimiento señalado en el inciso VI del presente Aviso de Privacidad.
							</p>
							<p style="font-weight: bold">IX.Atención de Quejas y Denuncias.</p>
							<p>
								En caso de que como Titular de los Datos Personales considere que su derecho a la protección de datos personales ha sido vulnerado, o bien que Madaeli le niega injustificadamente el ejercicio de los derechos ARCO, podrá acudir ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales para solicitar el inicio del procedimiento de protección de derechos en términos de lo previsto en el artículo 100 del Reglamento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, en sus instalaciones ubicadas en Insurgentes Sur No. 3211 Colonia Insurgentes Cuicuilco, Alcaldía Coyoacán, C.P. 04530, Ciudad de México, o bien al número telefónico (55) 50.04.24.00, o directamente en su página en Internet consultable en: https://home.inai.org.mx/.
							</p>
							<p style="font-weight: bold">
								X.Medio de comunicación con nosotros
							</p>
							<p>
								Si tiene cualquier duda sobre nuestro Aviso de Privacidad, por favor no dudes en ponerse en contacto con nuestro atención al cliente tras llamada, correo electrónico o whatsapp.
							</p>
							<p>
								Atención al cliente: 5593314662
							</p>
							<p>
								Email: plapla.service.2@gmail.com (Respuesta en 2 a 3 días laborales)
							</p>
							<p>
								WhatsApp:
							</p>
							<p>
								Tiempo laboral: De lunes a viernes 9:00-18:30, de sábado a domingo 9:00-14:30
							</p>
						</div>

						<div class="content">
							<div style="width: 100%; height: 27px; padding: 0 0 10px 0; border-top: 1px solid #ffffff;"></div>
							<div class="eshoy_abmessage_title">PlaPla Privacy Policy</div>
							<p style="margin-top: 27px;">Last Updated: 2026-03-04</p>
							<p>
								In compliance with the Federal Law on Protection of Personal Data Held by Private Parties (hereinafter the "Law"), its Regulations, and the Privacy Notice Guidelines (the latter published in the Official Gazette of the Federation on January 17, 2013), Madaeli, S.A. de C.V. and its Pla Pla application hereby provide this Privacy Notice and inform you of the following terms and conditions:
							</p>
							<p style="font-weight: bold">I. Personal Data Processing</p>
							<p>
								Madaeli, S.A. de C.V. (hereinafter Madaeli) and its Pla Pla application, located at RIO SAN JOAQUIN 463, Popo, Miguel Hidalgo, Mexico City, 11480, is responsible for obtaining, using, disclosing, storing, accessing, managing, utilizing, transferring, or disposing of personal data (hereinafter referred to as "Processing").
							</p>
							<p>
								Your data will be stored on Madaeli, S.A. de C.V.'s secure servers at: https://api.plapla.com.mx
							</p>
							<p>
								Under no circumstances will we share or sell your data to third parties. If you wish to delete your personal information, you may submit a request to customer service at: plapla.service.2@gmail.com, and we will manually process the deletion within 3 to 5 business days. Alternatively, you may submit the request directly in the app under Settings > Delete Account, and we will remove your personal data within a maximum of 7 business days. Deletion will be subject to the provisions of the Fintech Law and other applicable regulations regarding record retention.
							</p>
							<p>
								Under no circumstances will we share or sell your data to third parties. If you wish to delete your personal information, you may submit a request to customer service at: plapla.service.2@gmail.com, and we will manually process the deletion within 3 to 5 business days. Alternatively, you may submit the request directly in the app under Settings > Delete Account, and we will remove your personal data within a maximum of 7 business days. Deletion will be subject to the provisions of the Fintech Law and other applicable regulations regarding record retention.
							</p>
							<p style="font-weight: bold">II. Personal Data Subject to Processing</p>
							<p>
								Madaeli will collect the necessary personal data to fulfill its corporate purpose, policies on preventing and detecting operations with illicitly sourced funds and terrorism financing, and other corporate policies. This may be done directly through executives, officials, employees, or promoters, or indirectly through advisors or agents, using remote or local electronic, optical, or other technological means (e.g., our website, app, email, postal mail, online services, phone calls).
							</p>
							<p>
								Depending on your app version, PlaPla may require access to the following device permissions. Please keep the PlaPla app updated to ensure the use of secure and improved features.
							</p>
							<p>
								Personal data may include, but is not limited to:
							</p>
							<ul>
								<li>
									Identification Data: Full name, address, contact phone numbers, marital status, gender, country, place and date of birth, age, valid government-issued ID, Tax ID (RFC), Unique Population Registry Code (CURP), Advanced Electronic Signature (FIEL), email, academic data, and physical characteristics (e.g., photos, biometric data, geolocation).
								</li>
								<li>
									Personal Data: Employment information, monthly salary, payday, education level, bank details, account type, card number.
								</li>
								<li>
									Employment Data: Primary occupation, employment type, income sources, monthly income, workplace address, workplace phone, hire date, job position, supervisor’s name, additional productive activities.
								</li>
								<li>
									Commercial Data: Income sources, business activities, professional or business experience.
								</li>
								<li>
									Contact Data: Full name, address, occupation, phone number, contact relationship, marital status, gender, nationality, place and date of birth, age.
								</li>
								<li>
									Banking/Financial Data: Account type, card number, CLABE account, bank name. Used for disbursements and credit assessment to determine eligibility for our services and establish credit limits.
								</li>
								<li>
									SMS Financial Transactions: PlaPla accesses only financial SMS stored on your device (timestamps, phone numbers, and message content). Non-financial SMS data is never collected or shared. Automated models process this data for loan applications and risk assessment. Data is securely stored at https://api.plapla.com.mx and never shared without consent. To delete data, email plapla.service.2@gmail.com (processed in 3-5 business days).
								</li>
								<!--<li>
									La función de vinculación de cuenta Google obtiene su correo electrónico, nombre e información de perfil para facilitar el inicio de sesión rápido, verificar la elegibilidad para préstamos y prevenir fraudes. Mejora su crédito y agiliza el acceso.
								</li>-->
								<li>
									Receive SMS: PlaPla will send text messages to your registered mobile number, which may include payment deadlines, service updates, and relevant promotional content. Additionally, the SMS receiving function is utilized exclusively for the automatic verification of OTP (One-Time Password) codes sent to your device.
								</li>
								<li>
									Device Model & Status: Hardware model, build version, RAM, storage, unique identifiers (serial number, AAID, SIM info).
								</li>
								<li>
									Partners: Our Deeplink SDK (e.g., Google, Facebook) tracks user attribution but does not access social account data.
								</li>
								<li>
									Approximate Location: Helps fraud detection models verify identity and assess eligibility.
								</li>
								<li>
									Camera/Image Data: Required for ID and facial photos to verify loan applications. Stored for 1 year to authenticate documents and prevent fraud. To delete, email plapla.service.2@gmail.com (processed in 3-5 business days).
								</li>
								<li>
									Storage (Gallery Access): Only manually selected photos are encrypted and stored for 1 year for fraud prevention.
								</li>
								<li>
									Calendar: Used for payment reminders to avoid late fees.
								</li>
								<li>
									App Activity Data: Package name, app name, installation/update times.
								</li>
								<li>
									Contact Data: Manually selected emergency contacts (name, phone number) stored for 1 year. To delete, email plapla.service.2@gmail.com.
								</li>
								<li>
									Device Permissions: Logs when location, user info, or camera permissions are activated.
								</li>
								<li>
									Notifications: Can be disabled in device settings.
								</li>
								<li>
									Network Connectivity: Detects internet connection status.
								</li>
								<li>
									Wi-Fi Connections: Used for fraud prevention (IP address analysis).
								</li>
								<li>
									Internet Data Reception: Required for app functionality.
								</li>
								<li>
									Adjust SDK: Used for user behavior and ad attribution analysis. Privacy policy: https://www.adjust.com/terms/privacy-policy
								</li>
								<li>
									AppsFlyer SDK: Used for user behavior and ad attribution analysis. Privacy policy: https://www.appsflyer.com/legal/privacy-policy/
								</li>
							</ul>
							<p>
								All collected data is processed under strict security measures. Madaeli does not collect sensitive data (e.g., race, health status, religion, political views, sexual orientation).
							</p>
							<p style="font-weight: bold">III. Processing Purposes</p>
							<p>
								Data is used to:
							</p>
							<ul>
								<li>
									Verify identity and assess risk.
								</li>
								<li>
									Fulfill contractual/regulatory obligations.
								</li>
								<li>
									Maintain updated records.
								</li>
								<li>
									Authenticate users via biometric/biographic data.
								</li>
							</ul>
							<p>
								Data is obtained through:
							</p>
							<p>
								1. App download/loan applications.
							</p>
							<p>
								2. Customer service interactions.
							</p>
							<p>
								3. Financial institutions (with consent).
							</p>
							<p>
								4. Third-party providers (with consent).
							</p>
							<p style="font-weight: bold">
								IV. Right to Object to Processing
							</p>
							<p>
								If you disagree with this Privacy Notice, you have 5 business days from receipt to object by emailing plapla.service.2@gmail.com with the subject "Objection to Personal Data Processing." Note that refusal may prevent service provision.
							</p>
							<p style="font-weight: bold">V. Data Transfers</p>
							<p>
								Data may be shared with:
							</p>
							<ul class="number_ul">
								<li>
									Service Providers: Credit bureaus (e.g., TransUnion México, Circulo de Crédito), identity verification firms.
								</li>
								<li>
									Authorities: Mexican/financial/judicial entities for legal compliance.
								</li>
								<li>
									Adjust GmbH: For user attribution analytics.
								</li>
							</ul>
							<p>
								Transfers require recipient compliance with this Privacy Notice.
							</p>
							<p style="font-weight: bold">
								VI. ARCO Rights (Access, Rectification, Cancellation, Opposition)
							</p>
							<p>
								You may request to access, correct, or delete your data by submitting a written request to:
							</p>
							<p>
								Madaeli, RIO SAN JOAQUIN 463, Popo, Miguel Hidalgo, Mexico City, 11480
							</p>
							<p>
								Hours: 9:00 AM – 3:00 PM | Phone: 5593314662
							</p>
							<p>
								Requests are processed within 20 business days (extendable once if justified).
							</p>
							<p style="font-weight: bold">VII. Policy Updates</p>
							<p>
								Madaeli may modify this notice to reflect legal, operational, or market changes. Updates will be posted on our website, offices, or emailed.
							</p>
							<p style="font-weight: bold">VIII. Consent Withdrawal</p>
							<p>
								To revoke consent, follow the ARCO rights procedure (Section VI).
							</p>
							<p style="font-weight: bold">IX. Complaints</p>
							<p>
								If your data rights are violated, file a complaint with:
							</p>
							<p>
								National Institute for Transparency, Access to Information, and Personal Data Protection (INAI)
							</p>
							<p>
								Insurgentes Sur 3211, Col. Insurgentes Cuicuilco, Coyoacán, Mexico City, 04530
							</p>
							<p>
								Phone: (55) 5004-2400 | Website: https://home.inai.org.mx
							</p>
							<p style="font-weight: bold">
								X. Contact Us
							</p>
							<p>
								For questions, contact Customer Service:
							</p>
							<ul>
								<li>
									Phone: 55 8526 6878
								</li>
								<li>
									Email: plapla.service.2@gmail.com (response in 2-3 business days)
								</li>
								<li>
									WhatsApp:
								</li>
								<li>
									Hours: Mon-Fri 9:00 AM–6:30 PM | Sat-Sun 9:00 AM–2:30 PM
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footPage></footPage>
	</div>
	<div v-else class="mobile_viewrap">
		<div class="mobile_wrap">
			<mobNav :activeNav="activeNav"></mobNav>
		</div>
		<div class="mobile_content">
			<p>Actualización: 2025-07-18</p>
			<p>
				En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante la "Ley"), su Reglamento y los Lineamientos del Aviso de Privacidad, estos últimos publicados en el Diario Oficial de la Federación de fecha 17 de enero de 2013, Madaeli, S.A. de C.V.y su aplicación Pla Pla pone a su disposición el presente Aviso de Privacidad y hace de su conocimiento los términos y condiciones siguientes:
			</p>
			<p style="font-weight: bold">I. Del Tratamiento de los Datos Personales.</p>
			<p>
				Madaeli, S.A. de C.V.(en lo sucesivo Madaeli) y su aplicación Pla Pla, con domicilio en RIO SAN JOAQUIN 463 Popo Miguel Hidalgo Ciudad de México 11480, es responsable de la obtención, uso, divulgación, o almacenamiento, acceso, manejo, aprovechamiento, transferencia o disposición de datos personales (Adelante "Tratamiento").
			</p>
			<p>
				Sus datos serán almacenados en los servidores seguros de Madaeli, S.A. de C.V. ubicados en: https://api.plapla.com.mx
			</p>
			<p>
				En ningún caso compartiremos ni venderemos sus datos a terceros. Si desea eliminar su información personal, puede enviar una solicitud al servicio de atención al cliente al correo: plapla.service.2@gmail.com y procederemos a la eliminación manual en un plazo de 3 a 5 días hábiles. Alternativamente, puede enviar la solicitud directamente en la aplicación, en Configuración > Eliminar cuenta, y eliminaremos sus datos personales en un máximo de 7 días hábiles.La eliminación estará sujeta a lo establecido en la Ley Fintech y demás normativas aplicables en materia de conservación de registros.
			</p>
			<p style="font-weight: bold">II. Datos Personales sujetos a Tratamiento.</p>
			<p>
				Madaeli recabará Datos Personales necesarios para cumplir con su objeto social, políticas en materia de prevención y detección de operaciones con recursos de procedencia ilícita y financiamiento al terrorismo y demás políticas corporativas, ya sea personal, directamente a través de sus ejecutivos, funcionarios, empleados, promotores, o indirectamente por medio de sus asesores o comisionistas, pudiendo utilizar mecanismos en medios remotos o locales de comunicación electrónica, óptica u otra tecnología, como puede ser a través de nuestro portal web, aplicación, correo electrónico o postal, servicios en línea, vía telefónica, que le permitan recabar datos personales de manera automática y simultánea, incluyendo las referencias personales y comerciales que llegue a proporcionar el titular de la información.
			</p>
			<p>
				Según la versión de su aplicación, PlaPla podría requerir acceso a los siguientes permisos del dispositivo. Mantenga la aplicación PlaPla actualizada para garantizar el uso de funciones seguras y con las últimas mejoras.
			</p>
			<ul>
				<li>
					Datos de Identificación: nombre completo, dirección, teléfonos de contacto, estado civil, género, país, lugar y fecha de nacimiento, edad, identificación oficial vigente, registro federal de contribuyentes (RFC), clave única de registro de población (CURP), correo electrónico y sobre características físicas como son fotografías del poseedor de los datos o su domicilio, datos biométricos, geolocalización, entre otros.
				</li>
				<li>
					Datos Personales: informaciones laboral, salarios mensuales, día de cobro, nivel educativo, informaciones bancarias, tipo de cuenta, número de tarjeta.
				</li>
				<li>
					Datos de Contactos: nombre completo, número de teléfonos,La relación del .
				</li>
				<li>
					Datos Bancarios o patrimoniales: tipo de cuenta, número de tarjeta, cuenta CLABE, nombre del banco. Se utiliza para recibir desembolsos y evaluar crédito, a fin de determinar si cumple con los requisitos para usar nuestros servicios y establecer su línea de crédito.
				</li>
				<li>
					Datos de Cónyuge o Concubina: nombre completo, dirección, ocupación, teléfonos de contacto, estado civil, género, país, lugar y fecha de nacimiento, edad.
				</li>
				<li>
					<span style="font-weight: bold;">Leer tus transacciones financieras a través de SMS</span><span style="font-weight: bold;"> -</span>
					PlaPla accede únicamente a los mensajes SMS de carácter financiero almacenados en su dispositivo (incluyendo marcas de tiempo, números telefónicos y contenido de los mensajes), sin recopilar ningún dato no financiero de sus SMS ni compartir su contenido. Estos datos se procesan mediante modelos automatizados para evaluar solicitudes de préstamo, utilizando esta información en nuestros modelos de control de riesgos para determinar su elegibilidad para los servicios financieros. Toda la información se almacena de forma segura en nuestros servidores protegidos: https://api.plapla.com.mx. Nunca compartiremos datos con terceros sin su permiso, y la recopilación de SMS se realizará siempre bajo consentimiento. Si desea eliminar sus datos privados, puede enviar una solicitud al servicio de atención al cliente a este correo electrónico:plapla.service.2@gmail.com y podemos eliminarlos manualmente dentro de 3-5 días hábiles).
				</li>
				<li>
					Recibir mensajes de texto: Esta función se utiliza exclusivamente para la verificación automática de códigos OTP (contraseñas de un solo uso) enviados por SMS a su dispositivo.
				</li>
				<!--<li>
                    La función de vinculación de cuenta Google obtiene su correo electrónico, nombre e información de perfil para facilitar el inicio de sesión rápido, verificar la elegibilidad para préstamos y prevenir fraudes. Mejora su crédito y agiliza el acceso.
                </li>-->
				<li>
					Datos de Modelo y Estado del Dispositivo: información específica sobre su dispositivo, incluido su modelo de hardware, modelo de compilación, RAM, almacenamiento, identificadores únicos de dispositivo como número de serie, AAID, información SIM.
				</li>
				<li>
					Cooperadores: el SDK que utilizamos para conectar con el servicio de proveedor de Deeplink se entrega a través de múltiples canales (por ejemplo, Google, Facebook) con el fin de distinguir la fuente de atribución del canal del usuario y transmitir la identidad de cada canal, pero nuestro socio Deeplink no accede ni utiliza ninguna información de la cuenta social del usuario, tampoco nuestra propia app accede ni utiliza ninguna información de la cuenta social del usuario.
				</li>
				<li>
					Ubicación aproximada: Esta información contribuye a que nuestros modelos de detección de fraude verifiquen su identidad. PlaPla utiliza estos datos en sus modelos de control de riesgos para determinar su elegibilidad para acceder a los servicios de la plataforma.
				</li>
				<li>
					Cámara / Información de la imagen: Necesitamos obtener el permiso de cámara para tomar foto de identificación y foto facial.
				</li>
			</ul>
			<p>
				Los documentos proporcionados se utilizan exclusivamente para verificar que su solicitud de préstamo fue iniciada por usted mismo. Estas fotos se almacenarán en la nube para verificar la autenticidad del documento, la coherencia del usuario actual y del documento, que está diseñado para proteger sus fondos y optimizar sistema antifraude garantizando calidad de servicio de préstamo. Los datos se conservarán durante un año a partir de la fecha de carga. Las imágenes proporcionadas se utilizan para optimizar nuestros sistemas de prevención de fraude, garantizar la seguridad de sus fondos, verificar la autenticidad de los documentos y comprobar la correspondencia entre el solicitante actual y la identidad registrada. PlaPla no recopila imágenes sin su autorización expresa. Para solicitar la eliminación de estos datos, puede contactar a nuestro servicio al cliente enviando un correo electrónico a plapla.service.2@gmail.com, procediendo a la eliminación manual de la información dentro de un plazo de 3 a 5 días hábiles.
			</p>
			<p>
				Madaeli no recabará Datos Sensibles, es decir, aquellos que puedan revelar aspectos como origen racial o étnico, estado de salud presente y futuro, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas y preferencia sexual.
			</p>
			<ul>
				<li>
					Datos de Contactos: Necesitamos que seleccione manualmente el contactos de emergencia desde su lista de contactos incluido nombre y número de teléfono, esta función sirve para cuando no podemos poner en contacto contigo. Solamente los contactos seleccionados manualmente por los usuarios se transmitirán a nuestra aplicación de manera encriptada, y se guardarán por 1 año a partir de la fecha de carga. Nunca recopilaremos su información sin consentimiento. Si desea eliminar sus datos privados, puede enviar un correo electrónico a plapla.service.2@gmail.com. Envíe una solicitud al servicio de atención al cliente y podemos eliminarla manualmente dentro de (3-5 días hábiles).
				</li>
				<li>
					Datos de Permisos dentro del Dispositivo: en especifico, las informaciones que emiten tras la activación de permiso de ubicacion, informacion del usuario, camara.
				</li>
				<li>
					Notificaciones: Permiten a la aplicación PlaPla enviar alertas a su dispositivo. Puede desactivarlas en la configuración del sistema.
				</li>
				<li>
					Conectividad de red: Se utiliza para detectar cambios en la conexión y verificar su acceso a internet.
				</li>
				<li>
					Conexiones Wi-Fi: PlaPla analiza la dirección IP y tipo de red para prevenir actividades fraudulentas.
				</li>
				<li>
					Recepcion de datos de internet: Permite a la aplicación realizar solicitudes y acceder a servicios en línea.
				</li>
				<li>
					Adjust SDK: Utilizamos el SDK de Adjust para analizar el comportamiento de los usuarios dentro de la aplicación y la atribución de datos publicitarios. Consulte nuestra política de privacidad en: https://www.adjust.com/terms/privacy-policy
				</li>
				<li>
					AppsFlyer SDK: Utilizamos el SDK de AppsFlyerpara analizar el comportamiento de los usuarios dentro de la aplicación y la atribución de datos publicitarios. Políticas disponibles en: https://www.appsflyer.com/legal/privacy-policy/
				</li>
			</ul>
			<p>
				Todos los Datos Personales recabados serán tratados bajo estrictas medidas de seguridad, siempre garantizando su confidencialidad.
			</p>
			<p>
				Madaeli no recabará Datos Sensibles, es decir, aquellos que puedan revelar aspectos como origen racial o étnico, estado de salud presente y futuro, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas y preferencia sexual.
			</p>
			<p style="font-weight: bold">III.Finalidades del Tratamiento.</p>
			<p>
				Los Datos Personales que Madaeli recabe serán utilizados para realizar la verificación y confirmación de su identidad, análisis de riesgos, y que pudieran dar origen a una relación comercial entre Madaeli y usted como titular de los Datos Personales, siendo las finalidades:
			</p>
			<ul>
				<li>Dar cumplimiento a obligaciones contraídas con el Titular;</li>
				<li>
					Dar cumplimiento a obligaciones regulatorias emitidas por parte de las autoridades competentes, así como atender sus requerimientos;
				</li>
				<li>
					Mantener su información actualizada.
				</li>
				<li>
					Identificar al Titular.
				</li>
				<li>
					Evaluar riesgos y, en su caso, formalizar el contrato que derive de la relación comercial que se establezca entre las partes.
				</li>
				<li>
					Realizar validaciones de identidad a través de medios biométricos y biográficos de sus clientes.
				</li>
			</ul>
			<p>
				Los datos personales serán obtenidos y actualizados mediante los siguientes canales:
			</p>
			<p>
				1. Cuando descargue la aplicación PlaPla y/o solicite un préstamo con nosotros;
			</p>
			<p>
				2. A través de otras interacciones con nuestra organización, incluyendo información que comparta voluntariamente con nuestro servicio al cliente, empleados o agentes;
			</p>
			<p>
				3. Mediante instituciones de transferencia monetaria, proveedores de pagos electrónicos, plataformas de crowdfunding, entidades crediticias y otras instituciones financieras o de comercio electrónico, previo su consentimiento cuando sea requerido;
			</p>
			<p>
				4. A través de terceros y proveedores de servicios externos, siempre con su autorización expresa.
			</p>
			<p style="font-weight: bold">
				IV.Mecanismos para manifestación de negativa para tratamiento de sus Datos Personales.
			</p>
			<p>
				En caso de que no se encuentre de conformidad con el presente Aviso de Privacidad y del tratamiento de sus Datos Personales, contará con un plazo de 5 (cinco) días hábiles contados a partir de la entrega del presente Aviso de Privacidad para que, de ser el caso, manifieste su negativa para el tratamiento de sus Datos Personales.
			</p>
			<p>
				Para llevar a cabo el ejercicio de sus derechos de conformidad con lo señalado en el párrafo anterior, se pone a su disposición el correo electrónico plapla.service.2@gmail.com en el cual, dentro del asunto deberá señalar "Negativa para el Tratamiento de Datos Personales" manifestando en el cuerpo del correo sus datos de identificación a efecto de realizar lo conducente.
			</p>
			<p>
				En caso de manifestar su negativa para el tratamiento de sus Datos Personales en términos del presente Aviso de Privacidad, no se podrá concretar la relación jurídica, en el entendido que dicha información, es requerida para la prestación del servicio.
			</p>
			<p style="font-weight: bold">V.Transferencia de Datos.</p>
			<p>
				Madaeli podrá transferir sus Datos Personales a terceros, comprometiéndose a informar a dichos terceros del contenido del presente Aviso de Privacidad a fin de que tomen las medidas necesarias para respetar en todo momento los compromisos aquí descritos y asumidos por nosotros, mismos que serán extensivos para dichos terceros.
			</p>
			<p>
				Madaeli se cerciorará de que los terceros hayan emitido igualmente su correspondiente Aviso de Privacidad, cumpliendo así con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
			</p>
			<p>Los Datos Personales podrán ser transferidos a:</p>
			<ul class="number_ul">
				<li>
					Sociedades prestadoras de servicios, tales como: Trans Unión de México, S.A. S.I.C. (Buro de crédito), Circulo de crédito S.A. de C.V. S.I.C., Servicios Quien es Quien, S.A. de C.V., y cualquier otra que sea necesaria para verificar la identidad y veracidad de los datos proporcionados, únicamente con el propósito de dar cumplimiento a nuestras obligaciones legales y normativas derivadas de lo previsto en las leyes mexicanas.
				</li>
				<li>
					Autoridades mexicanas, cuando éstas lo requieran, para validar la autenticidad de los documentos presentados como identificación oficial por la contraparte.
				</li>
				<li>
					Autoridades financieras mexicanas y extranjeras, cuando éstas lo requieran con la finalidad de dar cumplimiento a nuestras obligaciones derivadas de leyes o tratados internacionales como entidad financiera, obligaciones tributarias, así como para el cumplimiento de notificaciones o requerimientos oficiales.
				</li>
				<li>
					Autoridades judiciales mexicanas y extranjeras, con la finalidad de dar cumplimiento a notificaciones, requerimientos u oficios de carácter judicial.
				</li>
				<li>
					Adjust GmbH: la función de este SDK es recopilar información sobre el origen de los usuarios y las operaciones que realizan en la plataforma.
				</li>
			</ul>
			<p>
				Todos los terceros mencionados pueden participar dentro de los procesos y cadena de valor ofrecida por Madaeli. En caso de ser necesaria la transferencia adicional de información que requiera su consentimiento expreso, éste se recabará con anticipación.
			</p>
			<p>
				Madaeli, podrá proporcionar información recabada previa y durante la vigencia de la relación jurídica entre las partes y para el cumplimiento de las obligaciones derivadas de lo anterior, a las entidades financieras que sean empresas controladoras, subsidiarias o filiales de Madaeli, así como a las autoridades competentes en México conforme a la legislación aplicable así como para el cumplimiento de obligaciones legales ante autoridades administrativas y judiciales garantizando previamente que dicha transferencia otorgue la continuidad de la protección de la información y el cumplimiento a lo señalado en el presente Aviso de Privacidad..
			</p>
			<p>
				El titular expresamente acepta y conviene que Madaeli podrá grabar cualquier comunicación telefónica que se realice entre el titular y Madaeli.
			</p>
			<p style="font-weight: bold">
				VI. Limitaciones en el uso y divulgación de sus Datos Personales y ejercicio de los derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)
			</p>
			<p>
				Usted tiene el derecho de acceder a sus Datos Personales que poseemos y a los detalles del tratamiento de estos, así como a rectificarlos en caso de ser inexactos o bien cancelar su uso a través de una solicitud mediante la presentación de un escrito libre dentro de las instalaciones de Madaeli, ubicadas en RIO SAN JOAQUIN 463 Popo Miguel Hidalgo Ciudad de México 11480; en un horario de 9:00 a 15:00 hrs., Teléfono 5593314662. Dicho requerimiento será atendido por la UNE (Unidad Especializada de Atención a Usuarios) en un plazo máximo de 20 (veinte) días hábiles, informándole sobre la procedencia a través del correo electrónico o el número telefónico que haya indicado en su solicitud y haciéndose efectiva, 15 (quince) días hábiles después de que se hubiera comunicado su resolución. Los plazos antes referidos podrán ser ampliados una sola vez por un periodo igual, siempre y cuando así lo justifiquen las circunstancias del caso, razones que se manifestarán al Titular, por escrito.
			</p>
			<p>
				Para ejercer los Derechos ARCO, el Titular, deberá presentar ante Madaeli, una solicitud que deberá contener y acompañar, como mínimo, lo siguiente:
			</p>
			<ul>
				<li>
					1. El nombre completo del Titular, domicilio y cuenta de correo electrónico o cualquier medio para comunicarle la respuesta a la solicitud.
				</li>
				<li>
					2. Los documentos que acrediten la identidad o, en su caso, la representación legal del Titular.
				</li>
				<li>
					3. La descripción clara y precisa de los Datos Personales sobre los cuales se desea ejercer algún Derecho ARCO.
				</li>
				<li>
					4. Para el caso de solicitar una rectificación, se deberá acompañar la documentación que respalde la rectificación solicitada.
				</li>
			</ul>
			<p>
				Madaeli se reserva el derecho de solicitar información y/o documentación adicional a la mencionada para atender la solicitud.
			</p>
			<p>
				Madaeli no estará obligado a cancelar los datos personales cuando: (i) Se refiera a las partes de un contrato y sean necesarios para su desarrollo y cumplimiento; (ii) deban ser tratados por disposición legal; (iii) sean necesarios para cumplir con una obligación legalmente adquirida por el Titular.
			</p>
			<p>
				La obligación de acceso a la información se dará por cumplida por parte de Madaeli, cuando ésta ponga a disposición del Titular de los Datos Personales directamente en el domicilio señalado en este inciso o se envíe al correo electrónico señalado por el Titular y elimine de su base de datos, dichos datos.
			</p>
			<p>
				Usted manifiesta expresamente que es de su conocimiento que en cualquier momento podrá oponerse al tratamiento de los datos que no sean esenciales para la relación jurídica y/o comercial que entabla con Madaeli, lo cual podrá efectuar mediante el procedimiento aquí señalado.
			</p>
			<p>
				En el tratamiento de sus datos personales, se prevé primordialmente que su resguardo sea contra todo daño, pérdida, alteración, destrucción, y ante todo uso, acceso o tratamiento no autorizado.
			</p>
			<p style="font-weight: bold">VII.Modificaciones al Aviso de Privacidad.</p>
			<p>
				Madaeli se reserva el derecho de efectuar en cualquier momento cambios o modificaciones al presente Aviso de Privacidad, ante la necesidad de proporcionarle la protección continua y adecuada a sus datos personales, así como para la atención de novedades legislativas o jurisprudenciales, políticas internas, y prácticas del mercado. Los cambios y modificaciones estarán disponibles a través de los siguientes medios: anuncios en nuestras oficinas y en el portal web de Madaeli, a través de nuestro personal que recabe sus Datos Personales y a través del envió a su último correo electrónico proporcionado.
			</p>
			<p style="font-weight: bold">VIII.Revocación del consentimiento.</p>
			<p>
				Como Titular de los Datos Personales podrá revocar el consentimiento concedido a Madaeli a fin de que se deje de hacer uso de los mismos, para lo cual se deberá seguir el procedimiento señalado en el inciso VI del presente Aviso de Privacidad.
			</p>
			<p style="font-weight: bold">IX.Atención de Quejas y Denuncias.</p>
			<p>
				En caso de que como Titular de los Datos Personales considere que su derecho a la protección de datos personales ha sido vulnerado, o bien que Madaeli le niega injustificadamente el ejercicio de los derechos ARCO, podrá acudir ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales para solicitar el inicio del procedimiento de protección de derechos en términos de lo previsto en el artículo 100 del Reglamento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, en sus instalaciones ubicadas en Insurgentes Sur No. 3211 Colonia Insurgentes Cuicuilco, Alcaldía Coyoacán, C.P. 04530, Ciudad de México, o bien al número telefónico (55) 50.04.24.00, o directamente en su página en Internet consultable en: https://home.inai.org.mx/.
			</p>
			<p style="font-weight: bold">
				X.Medio de comunicación con nosotros
			</p>
			<p>
				Si tiene cualquier duda sobre nuestro Aviso de Privacidad, por favor no dudes en ponerse en contacto con nuestro atención al cliente tras llamada, correo electrónico o whatsapp.
			</p>
			<p>
				Atención al cliente: 5593314662
			</p>
			<p>
				Email: plapla.service.2@gmail.com (Respuesta en 2 a 3 días laborales)
			</p>
			<p>
				WhatsApp:
			</p>
			<p>
				Tiempo laboral: De lunes a viernes 9:00-18:30, de sábado a domingo 9:00-14:30
			</p>
		</div>
		<div class="mobile_content">
			<div style="width: 100%; height: 27px; padding: 0 0 10px 0; border-top: 1px solid #ffffff;"></div>
			<div class="eshoy_abmessage_title">PlaPla Privacy Policy</div>
			<p style="margin-top: 27px;">Last Updated: 2025-07-18</p>
			<p>
				In compliance with the Federal Law on Protection of Personal Data Held by Private Parties (hereinafter the "Law"), its Regulations, and the Privacy Notice Guidelines (the latter published in the Official Gazette of the Federation on January 17, 2013), Madaeli, S.A. de C.V. and its Pla Pla application hereby provide this Privacy Notice and inform you of the following terms and conditions:
			</p>
			<p style="font-weight: bold">I. Personal Data Processing</p>
			<p>
				Madaeli, S.A. de C.V. (hereinafter Madaeli) and its Pla Pla application, located at RIO SAN JOAQUIN 463, Popo, Miguel Hidalgo, Mexico City, 11480, is responsible for obtaining, using, disclosing, storing, accessing, managing, utilizing, transferring, or disposing of personal data (hereinafter referred to as "Processing").
			</p>
			<p>
				Your data will be stored on Madaeli, S.A. de C.V.'s secure servers at: https://api.plapla.com.mx
			</p>
			<p>
				Under no circumstances will we share or sell your data to third parties. If you wish to delete your personal information, you may submit a request to customer service at: plapla.service.2@gmail.com, and we will manually process the deletion within 3 to 5 business days. Alternatively, you may submit the request directly in the app under Settings > Delete Account, and we will remove your personal data within a maximum of 7 business days. Deletion will be subject to the provisions of the Fintech Law and other applicable regulations regarding record retention.
			</p>
			<p style="font-weight: bold">II. Personal Data Subject to Processing</p>
			<p>
				Madaeli will collect the necessary personal data to fulfill its corporate purpose, policies on preventing and detecting operations with illicitly sourced funds and terrorism financing, and other corporate policies. This may be done directly through executives, officials, employees, or promoters, or indirectly through advisors or agents, using remote or local electronic, optical, or other technological means (e.g., our website, app, email, postal mail, online services, phone calls).
			</p>
			<p>
				Depending on your app version, PlaPla may require access to the following device permissions. Please keep the PlaPla app updated to ensure the use of secure and improved features.
			</p>
			<p>
				Personal data may include, but is not limited to:
			</p>
			<ul>
				<li>
					Identification Data: Full name, address, contact phone numbers, marital status, gender, country, place and date of birth, age, valid government-issued ID, Tax ID (RFC), Unique Population Registry Code (CURP), Advanced Electronic Signature (FIEL), email, academic data, and physical characteristics (e.g., photos, biometric data, geolocation).
				</li>
				<li>
					Personal Data: Employment information, monthly salary, payday, education level, bank details, account type, card number.
				</li>
				<li>
					Employment Data: Primary occupation, employment type, income sources, monthly income, workplace address, workplace phone, hire date, job position, supervisor’s name, additional productive activities.
				</li>
				<li>
					Commercial Data: Income sources, business activities, professional or business experience.
				</li>
				<li>
					Contact Data: Full name, address, occupation, phone number, contact relationship, marital status, gender, nationality, place and date of birth, age.
				</li>
				<li>
					Banking/Financial Data: Account type, card number, CLABE account, bank name. Used for disbursements and credit assessment to determine eligibility for our services and establish credit limits.
				</li>
				<li>
					SMS Financial Transactions: PlaPla accesses only financial SMS stored on your device (timestamps, phone numbers, and message content). Non-financial SMS data is never collected or shared. Automated models process this data for loan applications and risk assessment. Data is securely stored at https://api.plapla.com.mx and never shared without consent. To delete data, email plapla.service.2@gmail.com (processed in 3-5 business days).
				</li>
				<!--<li>
                    La función de vinculación de cuenta Google obtiene su correo electrónico, nombre e información de perfil para facilitar el inicio de sesión rápido, verificar la elegibilidad para préstamos y prevenir fraudes. Mejora su crédito y agiliza el acceso.
                </li>-->
				<li>
					Receive SMS: Used for OTP (one-time password) verification.
				</li>
				<li>
					Device Model & Status: Hardware model, build version, RAM, storage, unique identifiers (serial number, AAID, SIM info).
				</li>
				<li>
					Partners: Our Deeplink SDK (e.g., Google, Facebook) tracks user attribution but does not access social account data.
				</li>
				<li>
					Approximate Location: Helps fraud detection models verify identity and assess eligibility.
				</li>
				<li>
					Camera/Image Data: Required for ID and facial photos to verify loan applications. Stored for 1 year to authenticate documents and prevent fraud. To delete, email plapla.service.2@gmail.com (processed in 3-5 business days).
				</li>
				<li>
					Storage (Gallery Access): Only manually selected photos are encrypted and stored for 1 year for fraud prevention.
				</li>
				<li>
					Calendar: Used for payment reminders to avoid late fees.
				</li>
				<li>
					App Activity Data: Package name, app name, installation/update times.
				</li>
				<li>
					Contact Data: Manually selected emergency contacts (name, phone number) stored for 1 year. To delete, email plapla.service.2@gmail.com.
				</li>
				<li>
					Device Permissions: Logs when location, user info, or camera permissions are activated.
				</li>
				<li>
					Notifications: Can be disabled in device settings.
				</li>
				<li>
					Network Connectivity: Detects internet connection status.
				</li>
				<li>
					Wi-Fi Connections: Used for fraud prevention (IP address analysis).
				</li>
				<li>
					Internet Data Reception: Required for app functionality.
				</li>
				<li>
					Adjust SDK: Used for user behavior and ad attribution analysis. Privacy policy: https://www.adjust.com/terms/privacy-policy
				</li>
				<li>
					AppsFlyer SDK: Used for user behavior and ad attribution analysis. Privacy policy: https://www.appsflyer.com/legal/privacy-policy/
				</li>
			</ul>
			<p>
				All collected data is processed under strict security measures. Madaeli does not collect sensitive data (e.g., race, health status, religion, political views, sexual orientation).
			</p>
			<p style="font-weight: bold">III. Processing Purposes</p>
			<p>
				Data is used to:
			</p>
			<ul>
				<li>
					Verify identity and assess risk.
				</li>
				<li>
					Fulfill contractual/regulatory obligations.
				</li>
				<li>
					Maintain updated records.
				</li>
				<li>
					Authenticate users via biometric/biographic data.
				</li>
			</ul>
			<p>
				Data is obtained through:
			</p>
			<p>
				1. App download/loan applications.
			</p>
			<p>
				2. Customer service interactions.
			</p>
			<p>
				3. Financial institutions (with consent).
			</p>
			<p>
				4. Third-party providers (with consent).
			</p>
			<p style="font-weight: bold">
				IV. Right to Object to Processing
			</p>
			<p>
				If you disagree with this Privacy Notice, you have 5 business days from receipt to object by emailing plapla.service.2@gmail.com with the subject "Objection to Personal Data Processing." Note that refusal may prevent service provision.
			</p>
			<p style="font-weight: bold">V. Data Transfers</p>
			<p>
				Data may be shared with:
			</p>
			<ul class="number_ul">
				<li>
					Service Providers: Credit bureaus (e.g., TransUnion México, Circulo de Crédito), identity verification firms.
				</li>
				<li>
					Authorities: Mexican/financial/judicial entities for legal compliance.
				</li>
				<li>
					Adjust GmbH: For user attribution analytics.
				</li>
			</ul>
			<p>
				Transfers require recipient compliance with this Privacy Notice.
			</p>
			<p style="font-weight: bold">
				VI. ARCO Rights (Access, Rectification, Cancellation, Opposition)
			</p>
			<p>
				You may request to access, correct, or delete your data by submitting a written request to:
			</p>
			<p>
				Madaeli, RIO SAN JOAQUIN 463, Popo, Miguel Hidalgo, Mexico City, 11480
			</p>
			<p>
				Hours: 9:00 AM – 3:00 PM | Phone: 5593314662
			</p>
			<p>
				Requests are processed within 20 business days (extendable once if justified).
			</p>
			<p style="font-weight: bold">VII. Policy Updates</p>
			<p>
				Madaeli may modify this notice to reflect legal, operational, or market changes. Updates will be posted on our website, offices, or emailed.
			</p>
			<p style="font-weight: bold">VIII. Consent Withdrawal</p>
			<p>
				To revoke consent, follow the ARCO rights procedure (Section VI).
			</p>
			<p style="font-weight: bold">IX. Complaints</p>
			<p>
				If your data rights are violated, file a complaint with:
			</p>
			<p>
				National Institute for Transparency, Access to Information, and Personal Data Protection (INAI)
			</p>
			<p>
				Insurgentes Sur 3211, Col. Insurgentes Cuicuilco, Coyoacán, Mexico City, 04530
			</p>
			<p>
				Phone: (55) 5004-2400 | Website: https://home.inai.org.mx
			</p>
			<p style="font-weight: bold">
				X. Contact Us
			</p>
			<p>
				For questions, contact Customer Service:
			</p>
			<ul>
				<li>
					Phone: 55 8526 6878
				</li>
				<li>
					Email: plapla.service.2@gmail.com (response in 2-3 business days)
				</li>
				<li>
					WhatsApp:
				</li>
				<li>
					Hours: Mon-Fri 9:00 AM–6:30 PM | Sat-Sun 9:00 AM–2:30 PM
				</li>
			</ul>
		</div>
		<mobFooter></mobFooter>
	</div>
</template>

<script>
	import headNav from '@/components/headNav.vue'
	import homeNav from '@/components/homeNav.vue'
	import footPage from '@/components/foot.vue'
	import '../components/scss/Aviso.scss'
	import mobNav from '@/components/mobNav.vue'
	import mobFooter from '@/components/mobfooter.vue'
	import mobileOrpc from '@/mixins/index'

	export default {
		name: 'Aviso',
		components: { headNav, homeNav, footPage, mobNav, mobFooter },
		mixins: [mobileOrpc],
		data() {
			return {
				activeNav: '',
				scroll: 0,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
		methods: {
			handleScroll() {
				//或者使用document.querySelector('.class或者#id').scrollTop
				this.scroll = document.documentElement.scrollTop || document.body.scrollTop
			},
		},
		//销毁,否则跳到别的路由还是会出现
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll)
		},
	}
</script>

<style>
	.title p span {
		border-bottom: 3px solid #4e67f1;
	}
	.plapla_abmessage_cont {
		width: 1200px;
		height: auto;
		background: #13151a;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 63px 64px 0 64px;
	}

	.mobile_content {
		padding: 2rem 20px 20px 20px;
		display: flex;
		min-height: 100vh;
		flex-direction: column;
		max-width: 100vw;
		overflow: hidden;
		background: #13151a;
	}

	.mobile_content h4 {
		margin: 0 20px 10px;
		font-size: 0.36rem;
		text-align: center;
		color: #ffffff;
	}

	.mobile_content p,
	.mobile_content ul li {
		font-size: 0.4rem;
		color: rgba(255, 255, 255, 0.86);
		margin-bottom: 20px;
		word-wrap: break-word;
	}
</style>
